import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';

import { filterBoolean } from '@core/common-legacy';

import { RemoteTemplateActions, RemoteTemplateSelectors } from './remote-template.store';
import type { RemoteTemplate } from '../../../types';

@Injectable({ providedIn: 'root' })
export class RemoteTemplateStoreService {
  private readonly store = inject(Store);

  public getRemoteTemplates(integrationKind: string): Observable<RemoteTemplate[]> {
    return this.store
      .select(RemoteTemplateSelectors.entities({ scope: integrationKind }))
      .pipe(filterBoolean);
  }

  public getRemoteTemplatesLoading(integrationKind: string): Observable<boolean> {
    return this.store.select(
      RemoteTemplateSelectors.isPending({
        scope: integrationKind.toString(),
      }),
    );
  }

  public getRemoteTemplatesFailed(integrationKind: string): Observable<boolean> {
    return this.store.select(
      RemoteTemplateSelectors.isFailed({
        scope: integrationKind.toString(),
      }),
    );
  }

  public fetchRemoteTemplates(integrationKind: string): void {
    this.store.dispatch(
      RemoteTemplateActions.fetchCollection({
        payload: { scope: integrationKind.toString() },
      }),
    );
  }
}
